
//local imports
import { ToastMessage } from "@app/components";
import { Messenger } from "@app/shared";
import { AppStateService } from "@app/core";
// import {
//   PackageExportReadyNotification,
//   PackageExportStartedNotification,
// } from "@app/catalog-common";


export class PackageExportStateHandler {

  public initialize(appStateService: AppStateService, messager: Messenger) {

    //TODO:DIW:Should be in catalog, or notifications should be in platform
    // messager.subscribe(appStateService, PackageExportReadyNotification, (notification: PackageExportReadyNotification) => {
    //   console.log("Initializing PackageExportReadyNotification", notification);
    //   const message = notification.getMessage();
    //   messager.send(ToastMessage.create(message.message, message.level));
    //   appStateService.addNotification(message);
    // });

    // messager.subscribe(appStateService, PackageExportStartedNotification, (notification: PackageExportStartedNotification) => {
    //   console.log("Initializing PackageExportStartedNotification", notification);
    //   const message = notification.getMessage();
    //   messager.send(ToastMessage.create(message.message, message.level));
    //    appStateService.addNotification(message);
    // });

  }
}